import UseRecordService from '../../service/useRecord';

const Action = {
    GET_USE_RECORD: "GET_USE_RECORD",
    UPDATE_USE_RECORD: "UPDATE_USE_RECORD",
    LIST_USE_RECORD_BY_USER_ID: "LIST_USE_RECORD_BY_USER_ID",
    LIST_USE_RECORD_BY_GROUP_ID: "LIST_USE_RECORD_BY_GROUP_ID",
    LIST_USE_RECORD_BY_COMPANY_ID: "LIST_USE_RECORD_BY_COMPANY_ID",
    GET_USE_RECORD_BASIC_SETTING: "GET_USE_RECORD_BASIC_SETTING",
    GET_USE_RECORDS: "GET_USE_RECORDS",
};

const ActionCreator = {

    getUseRecordBasicSettings() {
        return async (dispatch) => {
            try {
                const basicSettings = await UseRecordService.getBasicSettings();
                dispatch({type: Action.GET_USE_RECORD_BASIC_SETTING, basicSettings});
                return basicSettings;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    updateBasicSetting(setting) {
        return async (dispatch) => {
            try {
                const basicSetting = await UseRecordService.updateBasicSetting(setting);
                await dispatch(ActionCreator.getUseRecordBasicSettings());
                return basicSetting;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getUseRecords() {
        return async (dispatch) => {
            try {
                const useRecords = await UseRecordService.list();
                dispatch({type: Action.GET_USE_RECORDS, useRecords});
                return useRecords;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getUseRecordsByUserId(userId) {
        return async (dispatch) => {
            try {
                const useRecords = await UseRecordService.listUseRecordByUserId(userId);
                dispatch({type: Action.LIST_USE_RECORD_BY_USER_ID, useRecords});
                return useRecords;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getUseRecordsByGroupId(groupId) {
        return async (dispatch) => {
            try {
                const useRecords = await UseRecordService.listUseRecordByGroupId(groupId);
                dispatch({type: Action.LIST_USE_RECORD_BY_USER_ID, useRecords});
                return useRecords;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getUseRecordsByCompanyId(companyId) {
        return async (dispatch) => {
            try {
                const useRecords = await UseRecordService.listUseRecordByCompanyId(companyId);
                dispatch({type: Action.LIST_USE_RECORD_BY_USER_ID, useRecords});
                return useRecords;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
};

const initialState = {
    basicSettings: [],
    list: []
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.GET_USE_RECORD_BASIC_SETTING:
            return {
                ...state,
                basicSettings: action.basicSettings
            };
        case Action.LIST_USE_RECORD_BY_USER_ID:
        case Action.LIST_USE_RECORD_BY_GROUP_ID:
        case Action.LIST_USE_RECORD_BY_COMPANY_ID:
        case Action.GET_USE_RECORDS:
            return {
                ...state,
                list: action.useRecords
            };
        default: {
            return state;
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/useRecord.js